// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3B6wm","inputWrap":"Table_inputWrap__Pm8xM","col":"Table_col__3xVQs","bmiTooltip":"Table_bmiTooltip__3gG8J"};